import { render, staticRenderFns } from "./ExportLabelButtons.vue?vue&type=template&id=57c50693"
import script from "./ExportLabelButtons.vue?vue&type=script&lang=ts"
export * from "./ExportLabelButtons.vue?vue&type=script&lang=ts"
import style0 from "./ExportLabelButtons.vue?vue&type=style&index=0&id=57c50693&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports